import { Container, Graphics, Sprite, Texture } from "pixi.js";
import { FadeScreen } from "../../game/components/FadeScreen";

export class Tooltip extends Container {
    private sprite: Sprite;
    private fadeScreen: FadeScreen;
    private fadeScreenMask: Graphics;

    public constructor(texture: Texture, fadeWidth: number, fadeHeight: number, type?: TooltipType, fadeAlpha?: number) {
        super();
        this.sprite = new Sprite(texture);
        this.createDarkenedBackground(fadeWidth, fadeHeight, type, fadeAlpha);
        this.addChild(this.sprite);
    }

    private createDarkenedBackground(fadeWidth: number, fadeHeight: number, type?: TooltipType, fadeAlpha?: number): void {
        const fade = fadeAlpha ?? 0.88;
        this.fadeScreen = new FadeScreen(0, fade, fade, fadeWidth, fadeHeight);
        this.addChild(this.fadeScreen);

        this.fadeScreenMask = new Graphics();
        this.fadeScreenMask.beginFill();
        this.fadeScreenMask.drawRoundedRect(0, 0, fadeWidth, fadeHeight, 40);
        this.fadeScreenMask.endFill();
        this.addChild(this.fadeScreenMask);
        this.fadeScreen.mask = this.fadeScreenMask;

        if (type && type == TooltipType.ToTop) {
            this.fadeScreen.position.y = this.sprite.height - fadeHeight;
            this.fadeScreenMask.position.y = this.sprite.height - fadeHeight;
        }
    }
}

export enum TooltipType {
    ToBottom,
    ToTop
}